import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link, Button } from '@zola/zola-ui';
import { showModal } from '../../../../actions/ModalActions';
import { setRegistryUrlError } from '../../../../actions/RegistryBulkImportActions';
import IncompleteIcon from '../../../../assets/images/registry/importRegistryAccountPage/incomplete.svg';
import CompleteIcon from '../../../../assets/images/registry/importRegistryAccountPage/complete.svg';
import InProgressIcon from '../../../../assets/images/registry/importRegistryAccountPage/in-progress.svg';

import './OtherRegistries.less';


const StatusElement = ({ syncStatus, lastSyncedDate }) => {
  let status;

  switch (syncStatus) {
    case 'PROCESSING':
      status = (
        <div className="other-registries__grid__row__status-column__status-container">
          <img
            className="other-registries__grid__row__status-column__icon"
            src={InProgressIcon}
            alt="Checklist"
          />
          <div>Adding to Zola</div>
        </div>
      );
      break;
    case 'FAILED':
      status = (
        <div className="other-registries__grid__row__status-column__status-container">
          <img
            className="other-registries__grid__row__status-column__icon"
            src={IncompleteIcon}
            alt="Checklist"
          />
          <div>
            <div className="other-registries__grid__row__status-column__status-incomplete">Sync incomplete {lastSyncedDate && <span>(Last Sync: {moment(lastSyncedDate).format('MM/DD/YY')})</span>}</div>
            <Link caret href="https://help.zola.com/hc/en-us/sections/115000736191-Adding-Gifts-and-Registries-From-Other-Stores">Learn More</Link>
          </div>
        </div>
      );
      break;
    case 'COMPLETED':
      status = (
        <div className="other-registries__grid__row__status-column__status-container">
          <img
            className="other-registries__grid__row__status-column__icon"
            src={CompleteIcon}
            alt="Checklist"
          />
          <div className="other-registries__grid__row__status-column__status">Sync complete: {moment(lastSyncedDate).format('MM/DD/YY')}</div>
        </div>
      );
      break;
    default:
      return '';
  }

  return status;
};

const OtherRegistriesRow = ({ storeName, registryUrl, enableEditAndDelete, registryId, confirmDeleteRegistry, syncStatus, lastSyncedDate, confirmEditRegistry, retailerDomain }) => (
  <div className="other-registries__grid__row">
    <div className="other-registries__grid__row__store-column">{storeName}</div>
    <div className="other-registries__grid__row__registrUrl-column">
      <div className="other-registries__grid__row__mobile-header visible-xs">
        <span>Registry Url  </span>
        {
          enableEditAndDelete && (
            <Link className="other-registries__grid__row__mobile-header__link" caret onClick={() => confirmEditRegistry(storeName, registryId, registryUrl, retailerDomain)}>
              Update Registry Url
            </Link>
          )
        }
      </div>
      <a className="other-registries__grid__row__registrUrl-column__url" href={registryUrl} rel="noopener noreferrer" target="_blank">{registryUrl}</a>
      {
        enableEditAndDelete && (
          <i
            className="zola-ui-icon zola-ui-icon-pencil other-registries__grid__row__edit-icon hidden-xs"
            type="button"
            data-toggle="tooltip"
            data-placement="top"
            title="Edit Registry URL"
            onClick={() => confirmEditRegistry(storeName, registryId, registryUrl, retailerDomain)}
          />
        )
      }
    </div>
    <div className="other-registries__grid__row__status-column">
      <div className="other-registries__grid__row__mobile-header visible-xs">Status</div>
      <StatusElement className="other-registries__grid__row__status-column__status" syncStatus={syncStatus} lastSyncedDate={lastSyncedDate} />
      {
        enableEditAndDelete && (
          <i
            className="zola-ui-icon zola-ui-icon-trash  other-registries__grid__row__edit-icon hidden-xs"
            type="button"
            data-toggle="tooltip"
            data-placement="top"
            title="Remove from Zola"
            onClick={() => confirmDeleteRegistry(storeName, registryId)}
          />
        )
      }
      {
        enableEditAndDelete && (
          <Button secondary error className="other-registries__grid__row__delete-button visible-xs" onClick={() => confirmDeleteRegistry(storeName, registryId)}>Remove From Zola</Button>
        )
      }
    </div>
  </div>
);

const mapDispatchToProps = dispatch => ({
  confirmDeleteRegistry: (retailerName, registryId) => dispatch(showModal('DELETE_OTHER_REGISTRIES_MODAL', { retailerName, registryId }, { size: 'md' })),
  confirmEditRegistry: (retailerName, registryId, registryUrl, retailerDomain) => {
    dispatch(setRegistryUrlError(false));
    dispatch(showModal('EDIT_OTHER_REGISTRIES_MODAL', { retailerName, registryId, registryUrl, retailerDomain }, { size: 'md' }));
  },
});

export default connect(
  null,
  mapDispatchToProps
)(OtherRegistriesRow);



// WEBPACK FOOTER //
// ./src/components/settings/registry/OtherRegistries/OtherRegistriesRow.jsx